<div class="suggested-matches-modal-overlay"></div>
<div class="suggested-matches-modal" (click)="onBackdropClick($event)">
  <div class="modal-content better-ui" (click)="$event.stopPropagation()">
    <span class="modal-close" (click)="onClose()"></span>
    <h2 class="modal-title">Suggested Matches</h2>
    <div class="matches-content better-ui">
      <!-- Loading indicator -->
      <div class="loading-spinner" *ngIf="isLoading">
        <div class="spinner"></div>
        <p>Loading...</p>
      </div>

      <!-- Error message -->
      <div class="error-message" *ngIf="errorMessage && !isLoading">
        <p>{{ errorMessage }}</p>
      </div>

      <!-- Matches list using shared card component -->
      <div class="matches-list better-ui" 
           *ngIf="!isLoading && !errorMessage && matchData.length > 0"
           (click)="clearSelection()">
        <div class="matches-table better-ui" (click)="$event.stopPropagation()">
          <app-suggested-match-card
            *ngFor="let match of matchData; let i = index"
            [match]="match"
            [index]="i"
            [selected]="selectedIndex === i"
            [someCardSelected]="selectedIndex !== null"
            (toggle)="onSelectCard($event)"
          ></app-suggested-match-card>
        </div>
        <div class="match-buttons" (click)="$event.stopPropagation()">
          <button class="btn btn-primary btn-yellow" [disabled]="selectedIndex == null || (selectedIndex != null  && !matchData[selectedIndex].required_Fields)" (click)="confirmMatch()"
          [matTooltip]="getTooltipText()"
          [matTooltipDisabled]="!showTooltip()">
            Confirm Match
          </button>
        </div>
      </div>
      
      <!-- No matches found -->
      <div class="no-matches better-ui" *ngIf="!isLoading && !errorMessage && matchData.length === 0">
        <p>No matches found.</p>
      </div>
    </div>
  </div>
</div>
